import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { Spin } from 'antd';
import { userHooks } from 'hooks';
import { userServices } from 'services';
import { IRoute } from 'data';
import { StoreContext } from 'contexts';
import { redirectToLoginPage } from 'helpers/auth';

const PrivateRoute = ({ component: Component, ...rest }: IRoute) => {
  useEffect(() => {
    // Tracking - Set userId when logged in
    const userInfo = userServices.getUserInfo();
    if (userInfo) {
      track('setUserId', userInfo.sub);
    }
  }, []);

  // Check if user is logged in or not
  if (!userServices.isLoggedIn()) {
    redirectToLoginPage();
    return null;
  }

  // Fetch global data
  const { currentUser } = userHooks.useUserInfo();

  // Show spin when fetching data
  if (!currentUser) {
    return <Spin className="app-spin" />;
  }

  return (
    <StoreContext.Provider
      value={{
        currentUser,
      }}
    >
      <Route {...rest} render={routeProps => <Component {...routeProps} />} />
    </StoreContext.Provider>
  );
};

export default PrivateRoute;
